export const SEGMENTS_LIST_ITEMS_PER_PAGE = 10;
